import { IconSvg } from '../../types'

export const CoffeeIcon: IconSvg = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 19C2.5 18.4477 2.94772 18 3.5 18H17.5C18.0523 18 18.5 18.4477 18.5 19C18.5 19.5523 18.0523 20 17.5 20H3.5C2.94772 20 2.5 19.5523 2.5 19Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 4C3.84315 4 2.5 5.34315 2.5 7V8C2.5 12.4183 6.08172 16 10.5 16C13.0264 16 15.2793 14.8289 16.7454 13H19C20.933 13 22.5 11.433 22.5 9.5C22.5 7.567 20.933 6 19 6H18.3293C17.9175 4.83481 16.8062 4 15.5 4H5.5ZM18.5 8C18.5 9.0609 18.2935 10.0736 17.9185 11H19C19.8284 11 20.5 10.3284 20.5 9.5C20.5 8.67157 19.8284 8 19 8H18.5ZM4.5 7C4.5 6.44772 4.94772 6 5.5 6H15.5C16.0523 6 16.5 6.44772 16.5 7V8C16.5 11.3137 13.8137 14 10.5 14C7.18629 14 4.5 11.3137 4.5 8V7Z"
        fill="currentColor"
      />
    </svg>
  )
}
